import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toArray',
})
export class ToArrayPipe implements PipeTransform {
  transform(value: any): number[] {
    if (!isFinite(value)) {
      return [];
    }
    return Array(value).map((a, i) => i);
  }
}
